let keyTracker = "";
let keyTimeout = null;
let openDropdown = null;

// Matches the whole label or any "/"-separated part of it, so "zagreb" finds "Europe/Zagreb"
const labelMatches = (label, startsWith) => {
	const normalized = (label || "").toLowerCase().replace(/_/g, " ").trim();
	return (
		normalized.startsWith(startsWith) ||
		normalized.split("/").some((part) => part.trim().startsWith(startsWith))
	);
};

export const findKeyElement = (choices, startsWith, isReact = false) =>
	Array.from(choices || []).find((item) =>
		labelMatches(
			isReact ? item?.innerText : item.children[1]?.innerText,
			startsWith,
		),
	);

export const highlightKeyElement = (targetElement, isReact = false) => {
	if (!targetElement) {
		return;
	}
	targetElement.scrollIntoView({
		behavior: "auto",
		block: "center",
		inline: "center",
	});
	targetElement.children[isReact ? 0 : 1]?.focus();
};

export const debounceKeyTracker = () => {
	clearTimeout(keyTimeout);
	keyTimeout = setTimeout(() => {
		keyTimeout = null;
		keyTracker = "";
	}, 500);
};

function trackDropdownKey(e) {
	// Ignore modifiers and navigation keys (Shift, ArrowDown, ...) so they don't end up in the search string
	if (e.key.length !== 1 || e.ctrlKey || e.metaKey || e.altKey) {
		return;
	}
	const nextSibling = document.activeElement.parentElement?.nextSibling;
	const choices = openDropdown.firstChild.childNodes;
	const key = e.key.toLowerCase();
	keyTracker += key;
	// Cycle to the next option only when the same single letter is pressed repeatedly ("a", "aa", ...)
	const keyIsRepeating =
		[...keyTracker].every((char) => char === key) &&
		labelMatches(nextSibling?.innerText, key);
	let targetElement = keyIsRepeating
		? nextSibling
		: findKeyElement(choices, keyTracker || key);
	if (keyTracker && !targetElement) {
		targetElement = findKeyElement(choices, key);
	}
	highlightKeyElement(targetElement);
	if (keyTracker) {
		debounceKeyTracker();
	}
}

export const initDropdownKeyTracking = (ids) => {
	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			const isVisible = entry.intersectionRatio > 0;
			if (isVisible) {
				window.addEventListener("keydown", trackDropdownKey);
				openDropdown = entry.target;
				openDropdown.firstChild.childNodes.forEach((item) => {
					item.children[1].tabIndex = -1;
				});
			} else {
				if (keyTimeout) {
					clearTimeout(keyTimeout);
				}
				keyTimeout = null;
				keyTracker = "";
				window.removeEventListener("keydown", trackDropdownKey);
				openDropdown = null;
			}
		});
	});
	ids.forEach((id) => observer.observe(document.getElementById(id)));
};
